/* ═══════════════════════════════════════════
   PAD RECOMMENDER POPUP — CAR FORCE SHOP
   Motyw: Horizon | v1.0
═══════════════════════════════════════════ */

(function () {
  'use strict';

  // ── Konfiguracja ──────────────────────────────────────────────────────────
  // URL do pliku JSON z konfiguracją (wygenerowany z panelu admina)
  const CONFIG_URL = '/assets/pad-recommender-config.json';

  // ── Dane kroków ───────────────────────────────────────────────────────────
  const STEPS = [
    {
      key: 'step1',
      title: 'Jaki etap pracy planujesz?',
      options: [
        { value: 'heavy_correction', icon: '⚡', label: 'Korekta ciężka', desc: 'Głębokie rysy, hologramy, mocne defekty' },
        { value: 'medium_correction', icon: '✨', label: 'Korekta średnia', desc: 'Swirle, drobne rysy, pajęczynki' },
        { value: 'finishing', icon: '💎', label: 'Wykończenie finalne', desc: 'Połysk, gloss, polerowanie finalne' },
        { value: 'protection', icon: '🛡️', label: 'Konserwacja / ochrona', desc: 'Aplikacja wosku, ceramiki, sealanta' },
      ],
    },
    {
      key: 'step2',
      title: 'Jakiej polerki używasz?',
      options: [
        { value: 'rotary', icon: '🔄', label: 'Rotacyjna / DA', desc: 'Rotary lub dual action (forced rotation)' },
        { value: 'orbital', icon: '🌀', label: 'Oscylacyjna', desc: 'Random orbital (RO)' },
        { value: 'manual', icon: '✋', label: 'Ręcznie / bez polerki', desc: 'Aplikacja ręczna lub bez maszyny' },
      ],
    },
    {
      key: 'step3',
      title: 'Jaki masz rodzaj lakieru?',
      options: [
        { value: 'hard', icon: '🇯🇵', label: 'Twardy lakier', desc: 'Japoński, ceramiczny, 2K' },
        { value: 'medium', icon: '🇩🇪', label: 'Średni lakier', desc: 'Europejski, standardowy' },
        { value: 'soft', icon: '🇮🇹', label: 'Miękki lakier', desc: 'Włoski, delikatny' },
        { value: 'unknown', icon: '❓', label: 'Nie wiem', desc: 'Dobierzemy bezpieczną opcję' },
      ],
    },
    {
      key: 'step4',
      title: 'Jakie masz doświadczenie?',
      options: [
        { value: 'beginner', icon: '🌱', label: 'Początkujący', desc: 'Dopiero zaczynam przygodę z detailingiem' },
        { value: 'intermediate', icon: '🔧', label: 'Średniozaawansowany', desc: 'Mam już pewne doświadczenie' },
        { value: 'professional', icon: '🏆', label: 'Profesjonalista', desc: 'Detailer / studio detailingowe' },
      ],
    },
  ];

  // ── Stan ──────────────────────────────────────────────────────────────────
  let config = null;
  let currentStep = 0;
  let answers = {};

  // ── Init ──────────────────────────────────────────────────────────────────
  async function init() {
    try {
      const res = await fetch(CONFIG_URL);
      config = await res.json();
    } catch (e) {
      console.warn('[PadRecommender] Nie można załadować konfiguracji:', e);
      config = { enabled: true, trigger: 'floating_button', triggerDelay: 0, mappings: [] };
    }

    if (!config.enabled) return;

    injectHTML();
    bindEvents();
    setupTrigger();
  }

  async function init() {
  try {
    const res = await fetch(CONFIG_URL);
    config = await res.json();
  } catch (e) {
    config = { enabled: true, showButton: true, trigger: 'floating_button', triggerDelay: 0, mappings: [] };
  }

  if (!config.enabled) return;

  injectHTML();
  bindEvents();
  setupTrigger();

  // ← DODAJ TO: ukryj przycisk jeśli showButton === false
  if (config.showButton === false) {
    const btn = document.getElementById('pad-recommender-btn');
    if (btn) btn.style.display = 'none';
  }
}


  // ── HTML ──────────────────────────────────────────────────────────────────
  function injectHTML() {
    // Button w headerze
    const btn = document.createElement('button');
    btn.id = 'pad-recommender-btn';
    btn.setAttribute('aria-label', 'Dobierz pad polerski');
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
      </svg>
      Dobierz pad
    `;

    // Wstaw do headera Horizon
    const headerActions =
      document.querySelector('.header__icons') ||
      document.querySelector('.header-wrapper .header__icon-list') ||
      document.querySelector('header .header__icons') ||
      document.querySelector('.site-header__icons') ||
      document.querySelector('header');

    if (headerActions) {
      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'display:flex;align-items:center;';
      wrapper.appendChild(btn);
      headerActions.insertBefore(wrapper, headerActions.firstChild);
    }

    // Overlay + modal
    const overlay = document.createElement('div');
    overlay.id = 'pad-recommender-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Konfigurator doboru pada polerskiego');

    overlay.innerHTML = `
      <div id="pad-recommender-modal">
        <div class="prm-header">
          <div>
            <h2>Dobierz odpowiedni pad</h2>
            <p>Odpowiedz na 4 pytania — dobierzemy idealne rozwiązanie</p>
          </div>
          <button class="prm-close" aria-label="Zamknij">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <div class="prm-progress">
          <div class="prm-progress-track">
            <div class="prm-progress-fill" style="width:25%"></div>
          </div>
          <div class="prm-progress-label">Krok 1 z 4</div>
        </div>

        <div class="prm-body">
          ${STEPS.map((step, i) => `
            <div class="prm-step${i === 0 ? ' is-active' : ''}" data-step="${i}">
              <p class="prm-step-title">${step.title}</p>
              <div class="prm-options">
                ${step.options.map(opt => `
                  <div class="prm-option" data-step="${i}" data-value="${opt.value}" role="button" tabindex="0">
                    <div class="prm-option-icon">${opt.icon}</div>
                    <div class="prm-option-text">
                      <strong>${opt.label}</strong>
                      <span>${opt.desc}</span>
                    </div>
                  </div>
                `).join('')}
              </div>
              <div class="prm-nav">
                ${i > 0 ? '<button class="prm-btn-back">← Wróć</button>' : '<span></span>'}
                <button class="prm-btn-next" disabled>Dalej →</button>
              </div>
            </div>
          `).join('')}

          <div class="prm-results" id="prm-results">
            <p class="prm-results-title">🎯 Twoje rekomendacje</p>
            <div class="prm-product-cards" id="prm-product-cards"></div>
            <div class="prm-results-footer">
              <button class="prm-btn-restart">← Zacznij od nowa</button>
              <a href="/cart" class="prm-btn-cart">Przejdź do koszyka →</a>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
  }

  // ── Events ────────────────────────────────────────────────────────────────
  function bindEvents() {
    // Otwórz
    document.getElementById('pad-recommender-btn')?.addEventListener('click', openModal);

    // Zamknij
    document.querySelector('.prm-close')?.addEventListener('click', closeModal);
    document.getElementById('pad-recommender-overlay')?.addEventListener('click', function (e) {
      if (e.target === this) closeModal();
    });

    // ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // Opcje
    document.querySelectorAll('.prm-option').forEach(function (el) {
      el.addEventListener('click', function () {
        const stepIdx = parseInt(this.dataset.step);
        const value = this.dataset.value;
        selectOption(stepIdx, value, this);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') this.click();
      });
    });

    // Dalej
    document.querySelectorAll('.prm-btn-next').forEach(function (btn) {
      btn.addEventListener('click', nextStep);
    });

    // Wróć
    document.querySelectorAll('.prm-btn-back').forEach(function (btn) {
      btn.addEventListener('click', prevStep);
    });

    // Restart
    document.querySelector('.prm-btn-restart')?.addEventListener('click', restart);
  }

  function setupTrigger() {
    if (config.trigger === 'page_load') {
      setTimeout(openModal, (config.triggerDelay || 3) * 1000);
    } else if (config.trigger === 'exit_intent') {
      document.addEventListener('mouseleave', function handler(e) {
        if (e.clientY <= 0) {
          openModal();
          document.removeEventListener('mouseleave', handler);
        }
      });
    }
    // floating_button — tylko przez klik w header button
  }

  // ── Logika kroków ─────────────────────────────────────────────────────────
  function selectOption(stepIdx, value, el) {
    // Odznacz inne w tym kroku
    document.querySelectorAll(`.prm-option[data-step="${stepIdx}"]`).forEach(function (o) {
      o.classList.remove('is-selected');
    });
    el.classList.add('is-selected');
    answers['step' + (stepIdx + 1)] = value;

    // Aktywuj przycisk Dalej
    const nextBtn = document.querySelector(`.prm-step[data-step="${stepIdx}"] .prm-btn-next`);
    if (nextBtn) nextBtn.disabled = false;
  }

  function nextStep() {
    const stepKey = 'step' + (currentStep + 1);
    if (!answers[stepKey]) return;

    if (currentStep < STEPS.length - 1) {
      goToStep(currentStep + 1);
    } else {
      showResults();
    }
  }

  function prevStep() {
    if (currentStep > 0) goToStep(currentStep - 1);
  }

  function goToStep(idx) {
    document.querySelectorAll('.prm-step').forEach(function (s) {
      s.classList.remove('is-active');
    });
    document.querySelector(`.prm-step[data-step="${idx}"]`)?.classList.add('is-active');
    currentStep = idx;
    updateProgress();

    // Przywróć stan przycisku Dalej
    const nextBtn = document.querySelector(`.prm-step[data-step="${idx}"] .prm-btn-next`);
    if (nextBtn) {
      nextBtn.disabled = !answers['step' + (idx + 1)];
    }
  }

  function updateProgress() {
    const pct = ((currentStep + 1) / STEPS.length) * 100;
    const fill = document.querySelector('.prm-progress-fill');
    const label = document.querySelector('.prm-progress-label');
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = `Krok ${currentStep + 1} z ${STEPS.length}`;
  }

  // ── Wyniki ────────────────────────────────────────────────────────────────
  function showResults() {
    // Ukryj kroki, pokaż wyniki
    document.querySelectorAll('.prm-step').forEach(function (s) {
      s.classList.remove('is-active');
    });

    const fill = document.querySelector('.prm-progress-fill');
    const label = document.querySelector('.prm-progress-label');
    if (fill) fill.style.width = '100%';
    if (label) label.textContent = 'Twoje rekomendacje';

    const resultsEl = document.getElementById('prm-results');
    const cardsEl = document.getElementById('prm-product-cards');
    if (!resultsEl || !cardsEl) return;

    // Znajdź pasujące mapowanie
    const match = findMapping();
    cardsEl.innerHTML = '';

    if (!match || match.products.length === 0) {
      cardsEl.innerHTML = `
        <div class="prm-no-results">
          😔 Nie znaleziono idealnego dopasowania.<br>
          <a href="/collections/all" style="color:#e63000;text-decoration:none;font-weight:600;">
            Zobacz wszystkie pady →
          </a>
        </div>
      `;
    } else {
      match.products.forEach(function (product) {
        const card = buildProductCard(product);
        cardsEl.appendChild(card);
      });
    }

    resultsEl.classList.add('is-active');
  }

  function findMapping() {
    if (!config.mappings || config.mappings.length === 0) return null;

    // Szukaj dokładnego dopasowania
    const exact = config.mappings.find(function (m) {
      return (
        m.step1 === answers.step1 &&
        m.step2 === answers.step2 &&
        m.step3 === answers.step3 &&
        m.step4 === answers.step4
      );
    });
    if (exact) return exact;

    // Fallback: dopasowanie po 3 krokach (ignoruj step4)
    const partial3 = config.mappings.find(function (m) {
      return (
        m.step1 === answers.step1 &&
        m.step2 === answers.step2 &&
        m.step3 === answers.step3
      );
    });
    if (partial3) return partial3;

    // Fallback: dopasowanie po 2 krokach (step1 + step2)
    return config.mappings.find(function (m) {
      return m.step1 === answers.step1 && m.step2 === answers.step2;
    }) || null;
  }

  function buildProductCard(product) {
    const card = document.createElement('div');
    card.className = 'prm-product-card';

    const price = parseFloat(product.price || 0).toFixed(2).replace('.', ',');

    card.innerHTML = `
      ${product.imageUrl
        ? `<img class="prm-product-img" src="${product.imageUrl}" alt="${escHtml(product.title)}" loading="lazy">`
        : `<div class="prm-product-img-placeholder"></div>`
      }
      <div class="prm-product-info">
        <p class="prm-product-name">${escHtml(product.title)}</p>
        ${product.justification ? `<p class="prm-product-justification">${escHtml(product.justification)}</p>` : ''}
        <p class="prm-product-price">${price} ${product.currency || 'PLN'}</p>
        <button class="prm-btn-atc" data-variant-id="${product.variantId}">
          Dodaj do koszyka
        </button>
      </div>
    `;

    card.querySelector('.prm-btn-atc').addEventListener('click', function () {
      addToCart(product.variantId, this);
    });

    return card;
  }

  // ── Koszyk ────────────────────────────────────────────────────────────────
  async function addToCart(variantId, btn) {
    if (!variantId) return;

    // Wyciągnij numeryczne ID z GID
    const numericId = variantId.includes('/')
      ? variantId.split('/').pop()
      : variantId;

    btn.disabled = true;
    btn.textContent = 'Dodawanie...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: numericId, quantity: 1 }),
      });

      if (!res.ok) throw new Error('Cart error');

      btn.textContent = '✓ Dodano!';
      btn.classList.add('is-added');

      // Odśwież licznik koszyka w Horizon
      refreshCartCount();
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Spróbuj ponownie';
      console.error('[PadRecommender] Błąd dodawania do koszyka:', e);
    }
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Horizon selektory licznika koszyka
        const counters = document.querySelectorAll(
          '.cart-count-bubble, .header__cart-count, [data-cart-count], .cart-count'
        );
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  function openModal() {
    document.getElementById('pad-recommender-overlay')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    document.getElementById('pad-recommender-overlay')?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function restart() {
    answers = {};
    currentStep = 0;
    document.querySelectorAll('.prm-option').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    document.querySelectorAll('.prm-btn-next').forEach(function (b) {
      b.disabled = true;
    });
    document.getElementById('prm-results')?.classList.remove('is-active');
    goToStep(0);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Start ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
